import {
    Grid,
    Tooltip,
    Typography,
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import React from 'react'
import { APPOINTMENT_TYPE, EVENT_TYPE } from '../constant'

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#fff',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 311,
        width: 311,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
        shadow: 'rgba(0,0,0,0.25) 10px 0 0',
        padding: '20px',
        borderRadius: '0',
    },
}))(Tooltip)

function DayCalendarEvent(props) {
    function handlePatientNameClick(id) {
        history.push(Routes.PROFILE, {
            userId: id,
            role: UserRoles.PATIENT,
        })
    }

    if (props.event.type === EVENT_TYPE.TIMEOFF) {
        return (
            <Grid
                container
                alignItems="center"
                justifyContent="space-between"
                className="event-wrap">
                <Grid container alignItems="flex-start">
                    <Typography noWrap>
                        <strong>{props.title}</strong>
                    </Typography>
                </Grid>
            </Grid>
        )
    }

    if (props.event.type === EVENT_TYPE.BUSY_SLOT) {
        return (
            <HtmlTooltip
                title={<ToolTipContent {...props.event} />}
                placement="top-start">
                <Grid container alignItems="center">
                    <Grid
                        item
                        xs={12}
                        className="day-event-wrap">
                        <span className="time">
                            {props.title}
                        </span>
                        <span className="title capitalize">
                            <a
                                href="#"
                                style={{ color: 'black' }}
                                onClick={(e) => {
                                    e.preventDefault()
                                    handlePatientNameClick(
                                        props.event
                                            .appointment
                                            .patient.id,
                                    )
                                }}>
                                {props.event.appointment
                                    .patient?.name ?? ''}
                            </a>
                        </span>
                        <span className="appointment-type">
                            {props.event.appointment
                                ?.type ===
                            APPOINTMENT_TYPE.TELE_HEALTH
                                ? 'Tele-health'
                                : 'In-clinic'}
                        </span>
                    </Grid>
                </Grid>
            </HtmlTooltip>
        )
    }

    if (props.event.type === EVENT_TYPE.FREE_SLOT) {
        return (
            <Grid
                container
                alignItems="center"
                justifyContent="flex-start"></Grid>
        )
    }

    return <></>
}

function ToolTipContent(props) {
    return (
        <div className="tooltip-wrapper">
            <div style={{ marginBottom: '10px' }}>
                <span className="date">
                    {props.slot.start_date.format(
                        'ddd DD MMM, YYYY',
                    )}
                </span>
                <span className="time">
                    {props.slot.start_date.format(
                        'hh:mm A',
                    )}
                </span>
            </div>

            {props.appointment?.patient?.name && (
                <Grid
                    container
                    style={{ marginBottom: '5px' }}>
                    <Grid item xs={4}>
                        <span className="gray">
                            Patient:
                        </span>
                    </Grid>
                    <Grid item xs={8}>
                        <Typography
                            noWrap
                            className="black capitalize">
                            {props.appointment?.patient
                                ?.name ?? ''}
                        </Typography>
                    </Grid>
                </Grid>
            )}
            <Grid container style={{ marginBottom: '5px' }}>
                <Grid item xs={4}>
                    <span className="gray">With:</span>
                </Grid>
                <Grid item xs={8}>
                    <Typography
                        noWrap
                        className="black capitalize">
                        {props.appointment.provider.name}
                    </Typography>
                </Grid>
            </Grid>
            <Grid container style={{ marginBottom: '5px' }}>
                <Grid item xs={4}>
                    <span className="gray">
                        Speciality:
                    </span>
                </Grid>
                <Grid item xs={8}>
                    <Typography
                        noWrap
                        className="black capitalize">
                        {
                            props.appointment.provider
                                .speciality?.name
                        }
                    </Typography>
                </Grid>
            </Grid>
            <Grid container style={{ marginBottom: '5px' }}>
                <Grid item xs={4}>
                    <span className="gray">Type:</span>
                </Grid>
                <Grid item xs={8}>
                    <Typography noWrap className="black">
                        {props.appointment.type ===
                        APPOINTMENT_TYPE.TELE_HEALTH
                            ? 'Tele-health'
                            : 'In-clinic'}
                    </Typography>
                </Grid>
            </Grid>
        </div>
    )
}

export default DayCalendarEvent
